import * as api from '../../api/api-dashboard-directo';
import {
    GET_RESUMEN_DIRECTO,
    GET_MESES_DIRECTO,
    GET_PROVEEDORES_DIRECTO,
    GET_KPIS_GLOBALES_DIRECTO,
    SET_FILTROS_DIRECTO
} from '../types';


// `meta.query` guarda con qué filtros se cargó el resumen: la exportación de casos (RG-602) debe usar
// esos mismos, no los que el usuario esté editando en el panel sin haber pulsado Buscar.
export const obtenerResumenDirecto = (query) => ({
    type: GET_RESUMEN_DIRECTO,
    payload: api.getResumenDirecto(query),
    meta: { query }
});
export const obtenerMesesDirecto = () => ({
    type: GET_MESES_DIRECTO,
    payload: api.getMesesDisponiblesDirecto()
});
export const obtenerProveedoresDirecto = () => ({
    type: GET_PROVEEDORES_DIRECTO,
    payload: api.getProveedores()
});
export const obtenerKpisGlobalesDirecto = () => ({
    type: GET_KPIS_GLOBALES_DIRECTO,
    payload: api.getKpisGlobales()
});
export const setFiltrosDirecto = (filtros) => ({
    type: SET_FILTROS_DIRECTO,
    payload: filtros
});
